<template>
  <div class="sidebar-wrapper d-flex justify-content-between flex-column flex-grow-1">
    <div class="p-2">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        aria-controls="sidebar-add-new-event"
        :aria-expanded="String(isEventHandlerSidebarActive)"
        variant="primary"
        block
        @click="$emit('update:isEventHandlerSidebarActive', true);"
      >
      {{ $t('Add Booking') }}
      </b-button>
      <div class="mt-3">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">{{ $t('Staff') }}</span>
        </h5>
        <b-form-group class="mb-2">
          <v-select
            v-model="selected_staff"
            :options="staffOptions"
            :searchable="true"
            :reduce="val => val.value"
            :clearable="false"
          />
        </b-form-group>
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">{{ $t('Room') }}</span>
        </h5>

        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedCalendars"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              @change="emit_now"
              v-for="item in calendarOptions"
              :key="item.label"
              name="event-filter"
              :value="item.id"
              class="mb-1"
              :class="`custom-control-${item.color}`"
            >
              {{ item.label }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton, BFormGroup, BFormCheckboxGroup, BFormCheckbox, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useCalendarSidebar from './useCalendarSidebar'
import vSelect from 'vue-select'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BImg,
    vSelect,
    BFormCheckbox,
    BFormGroup,
    BFormCheckboxGroup,
  },
  props: {
    isEventHandlerSidebarActive: {
      type: Boolean,
      require: true,
    },
  },
  watch: {
        'selected_staff': {
          handler(newValue, oldValue) {
            this.emit_now()
          }
        },
      },
  data() {
    return {
      selected_staff:null,
      staffOptions: [],
       calendarOptions:[],
      selectedCalendars:[],
    }
  },
  created() {
  //  console.clear()
    this.get_room()
    this.get_staff_list()
  },
  methods: {
        get_staff_list() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/staffs/select/')
        .then(res => {
          this.staffOptions = res.data
        })
    },
    emit_now() {
      this.$emit('fetch',this.selectedCalendars,this.selected_staff)
    },
    get_room() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/rooms/?enabled=y&center_id=`+ this.$store.getters['center/currentCenterId'])
        .then(res => {
          if (process.env.VUE_APP_VERSION != res.data.version) {
            this.$router.go(0);
          }
          this.calendarOptions = res.data.rooms
        })
    },
  },
}
</script>

<style>

</style>
